<template>
  <section class="relative flex h-full flex-1">
    <div class="relative z-10 md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
      <account-menu-mobile-component
        :data="data"
        :tabActive="tabActive"
        @active-tab="tabActive = $event"
        class="md:hidden"
      />
      <account-menu-component
        class="hidden md:flex"
        :data="data"
        :tabActive="tabActive"
        @active-tab="tabActive = $event"
      />
    </div>
    <div class="flex flex-1 flex-col pl-4 md:pl-64">
      <div is="transition" v-on:enter="enter" v-on:leave="leave" v-bind:css="true" mode="out-in">
        <component :is="tabActive"></component>
      </div>
    </div>
  </section>
</template>

<script>
import SocialLinksComponent from "../../components/social-links.component.vue";
import AccountMenuComponent from "../../components/account-menu.component.vue";
export default {
  name: "account",
  components: {
    profile: () => import("../profile/profile.component"),
    signature: () => import("../subscriptions/subscriptions.component"),
    messages: () => import("../notification/notification.component"),
    integration: () => import("../integration/integration.component"),
    // partner: () => import("../partner/partner.component"),
    // plans: () => import("../plans/plans.component"),
    bindings: () => import("../bindings/bindings.component"),
    cards: () => import("../cards/cards.component.vue"),
    preference: () => import("../preference/preference.component.vue"),
    AccountMenuMobileComponent: () => import("../../components/account-menu-mobile.component.vue"),
    SocialLinksComponent,
    AccountMenuComponent,
  },
  data() {
    return {
      data: [
        { tag: "profile", icon: this.$icons.profile, name: "Meus Dados" },
        {
          tag: "preference",
          icon: this.$icons.preference,
          name: "Preferências",
        },
        { tag: "signature", icon: this.$icons.signature, name: "Assinaturas" },
        { tag: "bindings", icon: this.$icons.bindings, name: "Vínculos" },
        // { tag: "plans", icon: this.$icons.plans, name: "Planos" },
        // { tag: "cards", icon: this.$icons.credit_card, name: "Cartão" },
        {
          tag: "messages",
          icon: this.$icons.email,
          name: "Mensagens",
        },
        {
          tag: "integration",
          icon: this.$icons.integration,
          name: "Segurança",
        },
      ],
      tabActive: "profile",
    };
  },

  computed: {
    // organiza 'data' alfabeticamente
    sortedData() {
      return this.data.sort((a, b) => {
        if (a.name < b.name) {
          return 0;
        }
        //if (a.name > b.name) {
        //  return 0;
        //}
        return 0;
      });
    },
  },

  mounted() {
    this.tabActive = this.$route.query.tag;
  },

  watch: {
    "$route.query.tag": {
      handler(value) {
        this.tabActive = value;
        return value;
      },
    },
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          scale: 1.2,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.95,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>
